const algoliaAppId = 'TLOBZ19IU2'
const algoliaApiKey = '35f32da8eec3571aa95b0cd8bdf7fb6e'
const depositaryMapSearchIndex = 'map_depositaire_groupe_totem'

export {
    algoliaAppId,
    algoliaApiKey,
    depositaryMapSearchIndex,
}
